<button class="update-button u-no-print" mat-raised-button
        color="primary"
        type="button" *ngIf="isShowTextEditor" (click)="disableAndSaveTextEditor()">Update</button>

<div id="{{id}}" class="editable-area" [style.width.px]="width" [style.height.px]="height" (click)="enableTextEditor()">
  <app-text-editor *ngIf="isShowTextEditor" [id]="id" [type]="PREVIEW_PDF" [content]="textFromEditor" [width]="width"></app-text-editor>
  <div *ngIf="isShowTextPreview" [style.width.px]="width" [style.height.px]="height" class="text o-flex--self-start" [innerHTML]="textFromEditor"></div>
</div>

